import { Button } from "@/components/ui/button";
import { ArrowRight, Play, Star, Users, Wallet } from "lucide-react";
import { Link } from "react-router-dom";
import heroBg from "@/assets/hero-bg.jpg";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-foreground/95 via-foreground/80 to-foreground/60" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-72 h-72 bg-primary/20 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }} />

      <div className="container relative z-10 py-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/20 backdrop-blur-sm border border-primary/30 mb-8 animate-fade-up">
            <Star className="w-4 h-4 text-accent" fill="currentColor" />
            <span className="text-sm font-medium text-primary-foreground">Nigeria's Learn & Earn Platform</span>
          </div>

          {/* Main Heading */}
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-primary-foreground leading-tight mb-6 animate-fade-up" style={{ animationDelay: '0.1s' }}>
            Learn Skills,{" "}
            <span className="text-gradient-gold">Earn Money</span>{" "}
            by Sharing
          </h1>

          {/* Subheading */}
          <p className="text-lg md:text-xl text-primary-foreground/80 mb-10 max-w-2xl animate-fade-up" style={{ animationDelay: '0.2s' }}>
            Pay ₦10,250 once to access all courses. Earn ₦4,000 for every friend you refer who joins. Learn, share, and earn!
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-12 animate-fade-up" style={{ animationDelay: '0.3s' }}>
            <Link to="/signup">
              <Button variant="gold" size="xl">
                Pay ₦10,250 & Start Learning
                <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
            <Link to="/courses">
              <Button variant="heroOutline" size="xl">
                <Play className="w-5 h-5" />
                Browse Courses
              </Button>
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap items-center gap-8 pt-8 border-t border-primary-foreground/10 animate-fade-up" style={{ animationDelay: '0.4s' }}>
            <div className="flex items-center gap-3">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="w-10 h-10 rounded-full bg-gradient-primary border-2 border-background flex items-center justify-center">
                    <Users className="w-4 h-4 text-primary-foreground" />
                  </div>
                ))}
              </div>
              <div>
                <p className="text-2xl font-bold text-primary-foreground">10,000+</p>
                <p className="text-sm text-primary-foreground/60">Active Learners</p>
              </div>
            </div>
            <div className="h-12 w-px bg-primary-foreground/20" />
            <div>
              <p className="text-2xl font-bold text-primary-foreground">50+</p>
              <p className="text-sm text-primary-foreground/60">Premium Courses</p>
            </div>
            <div className="h-12 w-px bg-primary-foreground/20" />
            <div className="flex items-center gap-2">
              <Wallet className="w-5 h-5 text-accent" />
              <div>
                <p className="text-2xl font-bold text-accent">₦4,000</p>
                <p className="text-sm text-primary-foreground/60">Per Referral</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
